import * as React from "react";
import { Section, SectionTitleDirection } from "../components/section";
import { StaticImage } from "gatsby-plugin-image";
import ExternalLink from "../components/externallink";
import { SEO } from "../components/seo";
import { LanguageContext } from "../components/layout";
import { WebsitePrivacyEN } from "../privacy/website-privacy-en";
import { WebsitePrivacyDE } from "../privacy/website-privacy-de";

const PrivacyPage = () => {
  const { lang, translations } = React.useContext(LanguageContext);
  
  return (
    <Section
      id="privacy"
      title={translations[lang].footerPrivacy}
      titleDirection={SectionTitleDirection.Left}
    >
      <div className="legalBox h-fit w-full">
        {lang === "en" ? <WebsitePrivacyEN /> : <WebsitePrivacyDE />}
      </div>
    </Section>
  );
};

export function Head() {
  return (
    <SEO title="Julian Ewers-Peters: Privacy Policy">
      <meta name="robots" content="noindex, nofollow" />
    </SEO>
  );
}

export default PrivacyPage;
